 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		80: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"pages/content/amlpolicy/pages/content/faq/pages/content/game-rules/pages/content/intellectual-proper/c889bfa8","27":"pages/cashbox/deposit/pages/cashbox/withdrawal","28":"pages/profile/pages/profile/bonuses/index","41":"header-c","42":"lang-ru.js","43":"lang-ua.js","44":"pages/auth/_social/cb","45":"pages/cashbox/deposit","46":"pages/cashbox/history","47":"pages/cashbox/index","48":"pages/cashbox/payin-error","49":"pages/cashbox/payin-status-ext","50":"pages/cashbox/payin-success","51":"pages/cashbox/payout-error","52":"pages/cashbox/payout-success","53":"pages/cashbox/support","54":"pages/cashbox/withdrawal","55":"pages/content/amlpolicy","56":"pages/content/faq","57":"pages/content/game-rules","58":"pages/content/intellectual-property","59":"pages/content/license","60":"pages/content/partners","61":"pages/content/privacy-policy","62":"pages/content/responsible-gaming","63":"pages/content/rules","64":"pages/error-game","65":"pages/game/_term","66":"pages/index","67":"pages/lobby/_section","68":"pages/lobby/_section/_sub-section","69":"pages/profile","70":"pages/profile/bonuses/index","71":"pages/profile/kycaid","72":"pages/profile/settings/index","73":"pages/profile/support-faq/index","74":"pages/promotions/_term","75":"pages/promotions/index","76":"pages/promotions/loyalty_system_promo_page/index","77":"pages/promotions/welcome-pack/index","78":"pages/registration","79":"pages/verifications/index","82":"vendors/pages/lobby/_section"}[chunkId]||chunkId) + "." + {"0":"909e903ee7de41b2c26d","1":"bf3cf5e3659f3507c6e1","2":"34e6c81d45dea76ae312","3":"1016296722330fff8634","4":"cb7c5942e4a2527f46b1","5":"75956137d751436f4960","6":"7a875253a2b5b2a4e0a1","7":"f1e12864a2a0cf89f478","8":"0e25e58ba63caca77409","9":"7920c3ec3f98bde87b60","10":"558baf8bac851db4d246","11":"0685ea8e322fd4d3d539","12":"3cef40ddbc449762c89a","13":"7ac0931db65a8e799963","14":"8b368ad0e4a41f7456e1","15":"dd4081c4ce75c1066978","16":"df53791464ebd6fe442e","17":"c84b8be2f7045075470b","18":"c6109407ed164a8c7b70","19":"f2b872421e53987a0c0c","20":"22b74db0397d6a16bf03","21":"027fec9331370b928f21","22":"8f2f02eef79292deae8b","23":"873439197ef1ac0f738a","24":"a62542846c7a53bbebce","25":"a1760be30d3ffc65d630","26":"eae0df7471f349387b99","27":"789115bb3f5a5d5e4cb4","28":"8fc9560cfd0dd34a90a6","29":"26730449ab1609442dd9","30":"eceaef2e226dbe50b863","31":"b657887e28688487be1d","32":"d75bce5058bcbfa6ac3c","33":"66cfc3cce1ce8c273e83","34":"99dde8ebf49b1491b525","35":"e6db98e10c8ffe94d937","36":"46cacde8f2fb0e9158cc","37":"b9e1bb73866206dbee30","38":"6e7bbf07c31b3a8d6a65","41":"4f54123b8be8e40c1810","42":"a805149dd22335196944","43":"0d30a2170d442ee96e77","44":"dd7a1b4f8f0ca6cce9d9","45":"23e6904d1e8ccad55649","46":"edaa502e1a70cec30362","47":"81844c89af6abf9d6a7a","48":"0125401b1ac1a603dbfc","49":"5dbafccc1de3b7a0ad35","50":"125a6feae93ec13aa23d","51":"c14d3f71df3d86a2c5a7","52":"647333b7d8a8e6398921","53":"962a3f154cb08ba6d45e","54":"358d4b6e73c5f700e472","55":"8733bd754a6abb3599ac","56":"27457d839143d4dec1bd","57":"d7b4597bc5fac9adebe7","58":"fb210bb275751caf1561","59":"b771824aa55e64968a22","60":"9862bf164b8fc7e4ede8","61":"2217057ce1299a660a00","62":"055658096eaf4ee1c921","63":"31f8b4f2847b4a858726","64":"be600b27e6cf7d4b262b","65":"f0a9b4c325e6534242eb","66":"9e40a7b3d43b419ab55a","67":"653d3a8994416592a138","68":"ba1109fb410bfd3e6d1d","69":"4a185172a81e3453dfbf","70":"b26ba934b0fecf1e704f","71":"323e464807f4213b7481","72":"36cfc609b036e7938beb","73":"9462ae9e5a53fd1e3da2","74":"b4444e7a5ad94e53008a","75":"2621da50455bac2a1848","76":"4b8a33b0bc66c3cc953b","77":"644647f2ab125921cdff","78":"fbc7a4b6e065248e6691","79":"aad1778505c037f0ac1f","82":"b1ce1f4d8c4aedbafb03","83":"f142454be6486282bb7d","84":"f311fcd5cd68a62a824c","85":"4f225ce776c34421ea7e","86":"1b55102232119f30d72d","87":"bee20063a83070ac86a9","88":"1bf1297b5ca48493094b","89":"cb5ef0c27649439f9229","90":"7ce5f629ee6f398c2a8c","91":"383a526a1b37c6eb7aa5","92":"007cdbf1875bbccd4513","93":"153e95bdfd1b1df17f5a","94":"bc15e23d52f1ed5139b0","95":"041b055b7f4fcb00226b","96":"5599dcdc0089f3401511","97":"98f1f63d4a663ca4c7fb","98":"8a25c44617b8f82d7680","99":"824ad2fa0515030ed5e8","100":"06a5aa3be8a44448d99d","101":"02103a71e03779d56b09","102":"1db8308080a38b7d26bd","103":"f11464c9d581d5f647c6","104":"a65f85260cb1740a639e","105":"e4eda1461382d099b15a","106":"975731fa5d1aa6f68170","107":"ace2101eb456253256ad","108":"8f7f4c98dfff9f32e630","109":"28ed1edb6f99c971786c","110":"ffbefc8a6e6c75471264","111":"042b56ca6dabeb34ba91","112":"d9d3768b3db8ed82e199","113":"f76b23f736f376d02c87","114":"0a77ff997be13e6a76ac","115":"0e53a78bb6d211de8152","116":"4cc3c66352b80caefc1c","117":"2d7bcaaab674c8f340a3","118":"132fc253b7a6432be614","119":"68ef8a8c3e25ee23f02a","120":"add16519bd5a89ca72d9","121":"e76aa28ac6a6adfcded7","122":"4825f6741dcc26b81a8c","123":"d81fa516db83de4f715a","124":"37b726489abcb74a8fb3","125":"f24ff62458a5ed317ff1","126":"ca2aff7b27b6f7fb23e8","127":"660c9eb1600ccac2648b","128":"ca2d1d1b64fe5f56220b","129":"d1b88950a297d05fe85b","130":"c3acd5e14d11f36e592a","131":"aa08ab220744e1d364ca","132":"9b8ae9ebaa1f6835aa68","133":"3aab26ad64fc8b815f63","134":"fbd106f9086dbe547e94","135":"1131eb04d23a6c3dd146","136":"4b35f68491e47854536f","137":"9b834f7db0d328ce6d82","138":"6cd79118e3a8042105bb","139":"843fe589f85f711973a9","140":"d7b51f5f4e039e3b3866","141":"51075a2d7adfc1b1dba5","142":"a8da1f471488368094ea","143":"1db2517031bf9b11bbfa","144":"e85004d9a2549db8977a","145":"0b832d91a334b5ff84af","146":"9a0930199a66cc72d205","147":"3ccf8077a36ef12acb22","148":"95246774179cb31ae310","149":"353ee32cd535fbaa63cb","150":"edaeabc4925c7e577372"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_static/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
